import React from 'react';
import SectionWrapper from '../../../../components/sectionWrapper/sectionWrapper';
import { styles } from './styles';

const DOCUMENTS = [
  {
    title: 'Terms of Use',
    summary: 'Who can join, what\'s allowed, how reporting works, and what happens to your account.',
    action: 'Read the Terms of Use',
    path: '/legal#terms',
  },
  {
    title: 'Privacy Policy',
    summary: 'What PlayerCafe collects, who can see it, how advertising uses it, and the choices you have.',
    action: 'Read the Privacy Policy',
    path: '/legal#privacy',
  },
];

function DocumentGlyph(): JSX.Element {

  return (
    <svg viewBox="0 0 36 44" style={styles.glyph} fill="none" stroke="currentColor" strokeWidth={1.5} aria-hidden>
      <path d="M1 1h24l10 10v32H1z" />
      <path d="M25 1v10h10" />
      <path d="M8 20h20M8 26h20M8 32h13" />
    </svg>
  );

}

export default function LegalLinks(): JSX.Element {

  return (
    <SectionWrapper id="legal" label="Legal" heading="Terms and privacy">
      <div className="pc-split" style={styles.grid}>
        {DOCUMENTS.map((document) => (
          <a key={document.path} href={document.path} style={styles.card}>
            <DocumentGlyph />
            <span style={styles.title}>{document.title}</span>
            <span style={styles.summary}>{document.summary}</span>
            <span style={styles.action}>{document.action} →</span>
            <span style={styles.address}>{window.location.host}{document.path}</span>
          </a>
        ))}
      </div>
      <p style={styles.note}>PlayerCafe is operated by Novaeon LLC, an Arizona company.</p>
    </SectionWrapper>
  );

}
